/**
 * Configurações da aplicação
 */

import { AppConfig } from '../types';

export const config: AppConfig = {
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001/api',
  defaultCenter: {
    lat: Number(process.env.REACT_APP_DEFAULT_CENTER_LAT) || -23.5505,
    lng: Number(process.env.REACT_APP_DEFAULT_CENTER_LNG) || -46.6333
  },
  defaultZoom: Number(process.env.REACT_APP_DEFAULT_ZOOM) || 12,
  minRadius: Number(process.env.REACT_APP_MIN_RADIUS) || 500,
  maxRadius: Number(process.env.REACT_APP_MAX_RADIUS) || 50000,
  defaultRadius: Number(process.env.REACT_APP_DEFAULT_RADIUS) || 5000
};

// Validação de configuração
export const validateConfig = (): boolean => {
  if (!config.googleMapsApiKey) {
    console.error('REACT_APP_GOOGLE_MAPS_API_KEY não configurada');
    return false;
  }
  return true;
};

// Constantes da aplicação
export const APP_CONSTANTS = {
  MAP_OPTIONS: {
    disableDefaultUI: false,
    zoomControl: true,
    mapTypeControl: false,
    scaleControl: true,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: true
  },
  CIRCLE_OPTIONS: {
    strokeColor: '#2196F3',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '#2196F3',
    fillOpacity: 0.2,
    clickable: false,
    editable: false
  },
  MARKER_ICON: {
    path: window.google?.maps?.SymbolPath?.CIRCLE || 0,
    scale: 8,
    fillColor: '#FF5722',
    fillOpacity: 1,
    strokeColor: '#ffffff',
    strokeWeight: 2
  }
};





